import { CustomCursor } from './components/effects/CustomCursor';
import { CustomScrollbar } from './components/effects/CustomScrollbar';
import Footer from './components/layout/Footer';
import Header from './components/layout/Header';
import Arkeflow from './sections/Arkeflow';
import Cases from './sections/Cases';
import ContactForm from './sections/ContactForm';
import Differentiators from './sections/Differentiators';
import Hero from './sections/Hero';
import Industries from './sections/Industries';
import Metrics from './sections/Metrics';
import Modalities from './sections/Modalities';
import Partners from './sections/Partners';
import Recruiting from './sections/Recruiting';
import Services from './sections/Services';
import Team from './sections/Team';
import ValueProps from './sections/ValueProps';

export default function App() {
  return (
    <>
      {/* Skip link para usuarios de teclado / lectores de pantalla — a11y §9.1 */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-etribe-yellow focus:text-etribe-blue focus:px-4 focus:py-2 focus:rounded-md focus:font-bold focus:shadow-lg"
      >
        Saltar al contenido principal
      </a>

      {/* Cursor magnético — solo se monta en desktop con motion habilitado */}
      <CustomCursor />

      {/* Scrollbar amarilla overlay — reemplaza la nativa para no reservar gutter */}
      <CustomScrollbar />

      <Header />
      <main id="main-content">
        <Hero />
        <ValueProps />
        <Metrics />
        <Services />
        <Cases />
        <Arkeflow />
        <Industries />
        <Partners />
        <Modalities />
        <Differentiators />
        <Recruiting />
        <Team />
        <ContactForm />
      </main>
      <Footer />
    </>
  );
}
